import React from 'react';
import SEO from '@/SEO';
import VedaStamp from '@/components/VedaStamp';


const HTML_CONTENT = `<h1>சாஸ்த்ரம் -ஆஹ்நிககாண்டம்</h1>`;

const AhnigamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ஆஹ்நிக காண்டம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AhnigamPage;
